<!--
Placeholder page to do the cache clear and then redirect to login.
If there's no data, being logged in is not a safe place to be...

@author cm359n
-->
<template>
  <div id="contain" class="container">
    <Logo style="margin-bottom:15px;" :unreadNum="unreadNotifications" :showNotif="1===1" :showWelcome="false" />
    <div style="text-align:center;margin-left:24px;margin-right:24px;padding-top:24px;">
      <p  style="display:inline-block;color:#003865;font-weight:bold;">{{ cacheClearMessage }}</p>
    </div>
    <div v-if="cacheCleared" style="text-align:center; margin-left:24px;margin-right:24px;">
      If you're not logged out within 10 seconds, please click:
      <button class="goToLoginBtn" @click="doLogout()">Log out</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

const router = useRouter()

// import axios from 'axios'
import Logo from '@/components/Logo.vue'
import * as lst from '@/components/localStorage.js'


const cacheClearMessage = ref('Please wait while we clear your cached UofGLife data...')
const cacheCleared = ref(false)
const unreadNotifications = ref(0)

  onMounted(() => {
    unreadNotifications.value = lst.getValue('unreadNotifications')
    console.log('clearing cache...')
    // The page has loaded! Clear the cache after a short (2s) delay
    setTimeout(() => {
      doCacheClear()
      // then log them out
      console.log('redirecting user to logout')
      doLogout()
    }, 2000)
})

function doCacheClear() {
  lst.clearAll()
  lst.clearAllLocalStorage()
  recordCacheClearDone()
  // note once the cache is clear we can't really record that it's been done
  // because the user info in the session is gone! :-/

  let errorOccurred = false
  let errorMessage
  if (typeof ClearData !== 'undefined') {
    console.log('found ClearData plugin, invoking ClearData.cache')
    ClearData.cache(function() {
      console.info('Successfully cleared app cache')
    }, function(err) {
      console.error('Error clearing app cache', err)
      errorOccurred = true
      errorMessage = err
    })
  } else {
    console.log('no ClearData plugin found so not using it')
  }
  if (errorOccurred) {
    cacheClearMessage.value = 'Error occurred: ' + errorMessage
  } else {
    cacheClearMessage.value = 'Cache cleared, logging you out ... '
  }
  cacheCleared.value = true
}

function recordCacheClearDone() {
  /* stolen with love from ToggleButton.vue
     because this is also a setting */
  axios.post('/timetable/settings', {}, {
        params: {
          settingName: 'CACHE_CLEAR_NEEDED',
          settingValue: 'N'
        }
      }).then(response => {
        console.log(response)
      })

}
/*
TODO
1) add a record for checking CACHE_CLEAR_NEEDED setting for the user
   and insert this into Login.vue hash

2) record this somewhere:
when the time comes for the Big Cache Clear, run this first:
update stt_applcnt_setting
set setting_value = 'Y' where setting_name = 'CACHE_CLEAR_NEEDED'

(and then...)
insert into stt_applcnt_setting
select distinct user_id, 'CACHE_CLEAR_NEEDED', 'Y'
from stt_applcnt_setting s
where not exists 
   (select 1 
    from stt_applcnt_setting 
    where user_id = s.user_id 
    and setting_name = 'CACHE_CLEAR_NEEDED');
*/


function doLogout () {
  setTimeout(() => {
    router.push('/logout')
  }, 2000)
}
  
</script>
<style>
#loginLogo2 {
  padding-top:40px;
  height:200px;
  background-color:#003865;
  text-align:center;
}

.goToLoginBtn {
  background-color:#003865;
  width:100%;
  color:#ffffff;
  font-family:PTSans;
  border: 1px solid #003865;
  border-radius:12px;
  height:52px;
  margin-top:24px;
  margin-bottom:21px;
  font-weight:700;
}

.helpdeskBtn {
  background-color:#ffffff;
  width:100%;
  color:#003865;
  font-family:PTSans;
  border: 1px solid #003865;
  border-radius:12px;
  height:52px;
  margin-bottom:21px;
  font-weight:700;
}

</style>
